import ReportsHeader from "./reports/Header/ReportsHeader";
import ReportsInfoBar from "./reports/Info Bar/ReportsInfoBar";
import {Alert} from "@mui/material";
import soleraBadge from "assets/solera_brand.png";
import soleraGradient from "assets/solera_gradient.png";
import React from "react";
import 'pages/reports/ReportsPage.css';

export const ErrorWrapperWithAppHeader = (props) => {
    const vin = props.vin;
    const reportData = props.reportData;
    const errorMessage = props.errorMessage;

    return (<div className={'pageContainer'}>
        <ReportsHeader vin={vin} setSelectedDatabases={props.setSelectedDatabases}
        />
        <ReportsInfoBar queriedData={reportData} withDownloadButton={true}></ReportsInfoBar>
        <div className='body'>
            <Alert icon={false} severity="error" variant="filled" className="alert">
                {errorMessage}
            </Alert>
        </div>
        <footer>
            <img className={'soleraBadge'} src={soleraBadge} alt='soleraBadge'/>
            <img className={'soleraGradient'} src={soleraGradient} alt={'soleraGradient'}/>
        </footer>
    </div>);
};